(function () {
    'use strict';

    angular.module("imApp").factory("userGroupEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 99,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 100,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
